import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import ChatRoom from './pages/ChatRoom';
import ConnectionView from './pages/ConnectionView';
import packageJson from '../package.json';


import './App.css';


function App() {
  return (
    <>
      <header className="App-header">
        <h1>
           RTT-TEST-CLIENT
        </h1>
        <p>
          Version: {packageJson.version}
        </p>
    </header>
      <Router>
        <Routes>
          <Route path='/' element={<ConnectionView />} />
          <Route path="/conference/:cid/:pid" element={<ChatRoom />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
